module.exports = __webpack_public_path__ + "img/banner-maskex3.cb340c37.webp";